'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var colors = require('../../../constants/colors.js');
var variants = require('../../../constants/variants.js');
var Badge_module = require('../styles/Badge.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Badge component is label with a background color
 *
 * @component
 * @example
 * ```jsx
 * <Badge color="green">Личные финансы</Badge>
 * ```
 */
const Badge = React__namespace.forwardRef((props, ref) => {
    const { text, variant, color, shape, placement, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Badge_module.default);
    const hasChildren = children !== undefined;
    const classNames = cx(className, 'container');
    const elementClassNames = cx('element', {
        [`color-${color}-${variant}`]: true,
        [`shape-${shape}`]: shape && text,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'shape-dot': !text,
        floating: hasChildren,
        [`floating-${placement}`]: hasChildren,
    });
    return (React__namespace.createElement("span", { ref: ref, "data-qa": "Badge", className: classNames, ...restProps },
        children,
        React__namespace.createElement("span", { className: elementClassNames }, text)));
});
Badge.defaultProps = {
    variant: variants.VARIANTS.SECONDARY,
    color: colors.COLORS.DARK,
    shape: 'round',
    placement: 'top-end',
};
Badge.displayName = 'Badge';

exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map
